import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, LinearProgress } from '@mui/material';

import { getNotificationTypesNotificationData, getPodsNotificationData } from '../../../../core/utils/notification_utils';
import { getAllPodsAction, getAllPodsState } from '../../../../features/pod/get_all_pods';
import useNotification from '../../../../core/hooks/use_notification';
import NotificationForm from './notification_form';
import { getNotificationTypesAction, getNotificationTypesState } from '../../../../features/communication/get_notification_types';
import { ROUTE_NOTIFICATIONS } from '../../../../core/constants';
import PageHeader from '../../../common/page_header';

const NotificationPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const getAllPods = useSelector(getAllPodsState);
    const getNotificationTypes = useSelector(getNotificationTypesState);

    const { showErrorMessage } = useNotification();

    useEffect(() => {
        dispatch(getAllPodsAction())
            .then(response => showErrorMessage(getPodsNotificationData(response)));
        dispatch(getNotificationTypesAction())
            .then(response => showErrorMessage(getNotificationTypesNotificationData(response)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3 } }>
            <PageHeader
                title="Nowe powiadomienie"
                showBack={ true }
                onBack={ () => navigate(ROUTE_NOTIFICATIONS, { state: location?.state }) }
            />

            { (getAllPods?.loading || getNotificationTypes?.loading) && (
                <Box sx={ { width: '100%' } }>
                    <LinearProgress/>
                </Box>
            ) }

            { (getAllPods?.data && getNotificationTypes?.data) && (
                <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1 } }>
                    <NotificationForm/>
                </Box>
            ) }
        </Box>
    );
};

export default NotificationPage;